export default {
    activate: "Aktiviraj",
    deactivate: "Deaktiviraj",
    delete: "Izbriši",
    edit: "Izmijeni",
    selected: "izabran(a)"
};
